import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWeightsAndBiasesComponent } from './simple-icons-weights-and-biases.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWeightsAndBiasesComponent ],
    exports:      [ SimpleIconsWeightsAndBiasesComponent ],
    bootstrap:    []
})
export class SimpleIconsWeightsAndBiasesModule {}
